import React from 'react';
import './index.less';

export const wrapperBoxInformationsShape = <div className="wrapperBoxInformationsShape" />;
